module.exports = __webpack_public_path__ + "static/media/profit-item.98d35727.gif";